import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../_services/authentication.service';


@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


        return next.handle(request).pipe(catchError(err => {
            console.log("ErrorInterceptor",err);
            if (err.status === 401) {
              console.log("err.status === 401");
                // auto logout if 401 response returned from api
                // alert('this.authenticationService.token '+ this.authenticationService.token )
                if(this.authenticationService.user ){
                  // try refresh
                  this.authenticationService
                  .verify()
                  .toPromise()
                  .then((res) => {
                    // user refreshed
                  })
                  .catch((err) => {
                    console.log('err', err);
                    this.authenticationService.logout();
                    location.reload();
                  });

                // alert('moli')
            }
            }

            const error = (err.error?.message ? err.error.message: (err.error ? err.error :  err.statusText));
            return throwError(error);
        }))
    }
}
